﻿export const accordion = () => {
  // Skip expand/collapse behavior if in edit mode
  if (document.documentElement.dataset.editMode === "true") {
    return;
  }

  const collapsedCssClass = "h-0",
    collapsedHeadingCssClass = "group-hover:pl-8";

  const sections = document.querySelectorAll(
    "[data-accordion-section]"
  ) as NodeListOf<HTMLElement>;

  const animationDuration = 200;

  function setBottomBorderHighlight(sectionContent: HTMLElement, highlighted: boolean) {
    const bottomBorder = sectionContent.parentElement?.querySelector(
      "hr[data-border]"
    ) as HTMLElement;

    if (highlighted) {
      bottomBorder.classList.add("text-primary-orange");
      bottomBorder.classList.remove("text-primary-silver");
    } else {
      bottomBorder.classList.add("text-primary-silver");
      bottomBorder.classList.remove("text-primary-orange");
    }
  }

  function setHeadingAnimate(sectionContent: HTMLElement, enabled: boolean) {
    const heading = sectionContent.parentElement?.querySelector<HTMLElement>(
      "div:first-of-type > h2"
    );

    if (enabled) {
      heading?.classList.add(collapsedHeadingCssClass);
    } else {
      heading?.classList.remove(collapsedHeadingCssClass);
    }
  }

  function expand(sectionContent: HTMLElement, contentHeight: number) {
    sectionContent.classList.remove(collapsedCssClass);

    sectionContent.style.height = `${contentHeight}px`;

    // HACK Allow time for animation to complete before switching to auto-height
    setTimeout(() => {
      sectionContent.style.height = "auto";

      toggleIcon(sectionContent);

      // Highlight bottom border
      setBottomBorderHighlight(sectionContent, true);

      // Heading shouldn't animate in expanded section
      setHeadingAnimate(sectionContent, false);
    }, animationDuration);
  }

  function collapse(sectionContent: HTMLElement, contentHeight: number) {
    sectionContent.style.height = `${contentHeight}px`;

    // HACK Avoid instant collapse
    setTimeout(() => {
      sectionContent.style.height = "0px";

      sectionContent.classList.add(collapsedCssClass);

      // Reset bottom border color
      setBottomBorderHighlight(sectionContent, false);

      toggleIcon(sectionContent);

      // Heading should animate on hover for collapsed sections
      setHeadingAnimate(sectionContent, true);
    }, 0);
  }

  function toggleIcon(sectionContent: HTMLElement) {
    const hiddenIcon = sectionContent.parentElement?.querySelector(
      "div:first-of-type > svg.hidden"
    ) as SVGElement;

    const activeIcon = sectionContent.parentElement?.querySelector(
      "div:first-of-type > svg:not(.hidden)"
    ) as SVGElement;

    activeIcon.classList.add("hidden");

    hiddenIcon.classList.remove("hidden");
  }

  sections.forEach(section => {

    const sectionHeading = section.querySelector("[data-section-heading]") as HTMLElement | undefined;

    if (!sectionHeading) {
      console.error("Unable to find accordion section heading");

      return;
    }

    sectionHeading.onclick = event => {
      const clickedElement = event.target as HTMLElement;

      let clickedSection: HTMLElement;

      if (clickedElement.hasAttribute("data-accordion-section")) {
        clickedSection = clickedElement;
      } else {
        clickedSection = clickedElement.closest("[data-accordion-section") as HTMLElement;
      }

      const sectionContent = clickedSection.querySelector(
        "[data-accordion-section-content]"
      ) as HTMLElement;

      const isCollapsed = sectionContent.classList.contains(collapsedCssClass);

      const sectionContentInnerWrapper = sectionContent.firstElementChild as HTMLElement;

      const contentHeight = sectionContentInnerWrapper.getBoundingClientRect().height;

      if (isCollapsed) {
        expand(sectionContent, contentHeight);
      } else {
        collapse(sectionContent, contentHeight);
      }
    };

    // Ensure links are still clickable without trigger expand/collapse
    section.querySelectorAll<HTMLAnchorElement>("a").forEach(a => {
      a.onclick = event => {
        event.stopPropagation();
      };
    });
  });
};
